import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Placeholder for future link functionality
    console.log('Footer link clicked');
  };

  return (
    <Box 
      component="footer" 
      className="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'white',
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {/* Links centered at the top */}
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: { xs: 2, sm: 3 },
              mb: 2
            }}
            className="footer-links"
          >
            <Link 
              href="http://www.3eco.com/about" 
              color="text.secondary" 
              onClick={handleLinkClick}
              underline="hover"
              className="footer-link"
            >
              {t('footer.about', 'About 3E')}
            </Link>
            <Link 
              href="https://www.3eco.com/privacy" 
              color="text.secondary" 
              onClick={handleLinkClick}
              underline="hover"
              className="footer-link"
            >
              {t('footer.privacy', 'Privacy Notice')}
            </Link>
            <Link 
              href="https://www.3eco.com/termsofuse" 
              color="text.secondary" 
              onClick={handleLinkClick}
              underline="hover"
              className="footer-link"
            >
              {t('footer.terms', 'Terms of Use')}
            </Link>
            <Link 
              href="http://www.3eco.com/contact-us-3e" 
              color="text.secondary" 
              onClick={handleLinkClick}
              underline="hover"
              className="footer-link"
            >
              {t('footer.contact', 'Contact 3E')}
            </Link>
          </Box>
          
          {/* Copyright info below the links */}
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ mt: 1 }}
          >
           {t('footer.copyright', 'Copyright')} 3E © {new Date().getFullYear()} - {t('footer.allRightsReserved', 'All rights reserved.')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;